// Cover Sheet commission splits (§1) — pure helpers.
//
// A job can pay no commission. That is stored in the same CommissionSplitsJson
// array as one marker row ({ no_commission: true }), so no column or proc
// changes and every older reader still sees a plain array. A marker row, not an
// empty array, because an empty array reloads as the default salesperson row.

const NA_NAME = /^(n\/?a|not applicable|none|no commission)$/i;

export const noCommissionSplits = () => [{ id: Date.now() + Math.random(), no_commission: true, name: "", role: "", split_pct: "" }];

// True for the marker row, and for a single row whose name was typed as
// "Not applicable" / "N/A" / "None" (what people did before the checkbox).
export function isNoCommission(splits) {
  const rows = Array.isArray(splits) ? splits : [];
  if (rows.some(r => r?.no_commission === true)) return true;
  return rows.length === 1 && NA_NAME.test(String(rows[0]?.name || "").trim());
}

// What Section 1 completion needs from the splits: nothing when there are no
// rows or no commission; otherwise the splits must total 100%.
export function commissionIssue(splits) {
  const rows = Array.isArray(splits) ? splits : [];
  if (rows.length === 0 || isNoCommission(rows)) return null;
  const total = rows.reduce((sum, r) => sum + (parseFloat(r.split_pct) || 0), 0);
  return Math.round(total) === 100 ? null : `Commission splits total ${Math.round(total)}% — must equal 100%`;
}
